import { IDataSourceRevision } from '../types/IContentRevision';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetDatasourceVersionsParams extends IGetItemsParams {
}

export interface IGetDatasourceVersionsResult extends IGetItemsResult {
  versions: IDataSourceRevision[];
}

export class GetDatasourceVersionsRequest extends Request<IGetDatasourceVersionsParams, IGetDatasourceVersionsResult> {
  constructor(params: IGetDatasourceVersionsParams) {
    super('getDatasourceVersions', params);
  }
}
